import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Tooltip from 'gnos-tooltip'

import cx from 'classnames'

import './style.scss'

export default class Indicator extends Component {
    static propTypes = {
        activeValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
        activeValueMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        clickHandler: PropTypes.func,
        clickIdentifier: PropTypes.string.isRequired,
        headerMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        historicalValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
        historicalValueMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        identifier: PropTypes.string.isRequired,
        noMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        riskIndicator: PropTypes.bool,
        tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    }

    handleOnClick = () => {
        const { clickHandler, clickIdentifier, activeValue, historicalValue } = this.props

        if (clickHandler && (activeValue || historicalValue)) {
            clickHandler(clickIdentifier)
        }
    }

    render() {
        const {
            headerMessage,
            identifier,
            activeValue,
            historicalValue,
            riskIndicator,
            activeValueMessage,
            historicalValueMessage,
            noMessage,
            tooltip,
        } = this.props

        const content = (
            <div className={cx('indicator-item', 'indicator-section')}>
                <div className={'indicator-item-header'}>{headerMessage}</div>
                <div className={'indicator-content'} onClick={this.handleOnClick}>
                    <div
                        className={cx(
                            'indicators-image',
                            !activeValue && historicalValue && `${identifier}-past`,
                            activeValue && `${identifier}-present`,
                            !activeValue && !historicalValue && 'na',
                            riskIndicator && 'risk'
                        )}
                    />
                    <div className={'indicator-message'}>
                        {activeValue && activeValueMessage}
                        {!activeValue && historicalValue && historicalValueMessage}
                        {!activeValue && !historicalValue && noMessage}
                    </div>
                    <div className={cx('indicator-item-footer ', (activeValue || historicalValue) && 'magnifier')} />
                </div>
            </div>
        )

        return tooltip ? (
            <Tooltip id={`indicator_tooltip_${identifier}`} content={tooltip} key={`indicator_tooltip_${identifier}`}>
                {content}
            </Tooltip>
        ) : (
            content
        )
    }
}
